import React, { useEffect } from "react";
import Empresa from "../components/Empresas/Empresa";
import i18n from "../i18n/config";

const EmpresaPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("empresa.layoutTitle", { ns: "empresaNovedadDetails" })}`;
  }, []);

  return <Empresa />;
};

export default EmpresaPage;
